<template>
  <transition appear @before-enter="beforeEnterH1" @enter="enterH1">
    <h1>{{ "" }}</h1>
  </transition>
  <transition appear @before-enter="beforeEnterBox" @enter="enterBox">
    <h2 data-index="1">My Profile:</h2>
  </transition>
  <table class="grid">
    <thead>
      <img :src="avatar" alt="profile avatar" />
    </thead>
    <transition-group
      appear
      tag="tbody"
      @before-enter="beforeEnter"
      @enter="enter"
    >
      <tr :key="0" data-index="0" class="flex">
        <td class="table-key">Full Name:</td>
        <td class="table-value">{{ name }}</td>
      </tr>
      <tr :key="1" data-index="1" class="flex">
        <td class="table-key">Phone:</td>
        <td class="table-value">{{ contact.phone1 }}, {{ contact.phone2 }}</td>
      </tr>
      <tr :key="2" data-index="2" class="flex">
        <td class="table-key">Email:</td>
        <td class="table-value">
          {{ contact.email1 }}
        </td>
      </tr>
      <tr :key="3" data-index="3" class="flex">
        <td class="table-key">Address:</td>
        <td class="table-value">
          {{ contact.address }}
        </td>
      </tr>
      <tr :key="4" data-index="4" class="flex">
        <td class="table-key">GitHub Page:</td>
        <td class="table-value">
          <a :href="website" target="_blank">LahoucineABOULHASSAN</a>
        </td>
      </tr>
    </transition-group>
  </table>
</template>

<script>
export default {
  props: {
    name: String,
    avatar: String,
    website: String,
    contact: Object,
    beforeEnterH1: Function,
    enterH1: Function,
    beforeEnter: Function,
    enter: Function,
    beforeEnterBox: Function,
    enterBox: Function,
  },
};
</script>

<style scoped>
table {
  grid-template-columns: 1fr 3fr;
  max-height: 250px;
  margin-bottom: 1.7rem;
}

thead {
  max-height: 250px;
}
tbody {
  padding: 0.5rem;
}
thead img {
  width: 200px;
  max-height: 250px;
  border-radius: 15px;
  border: none;
  margin: 0 auto;
}
tbody tr {
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 1.1rem;
  line-height: 1.7;
  letter-spacing: 1px;
}
tbody .table-key {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.9rem;
}
@media screen and (max-width: 800px) {
  table {
    grid-template-columns: 1fr;
    max-height: inherit;
  }
  thead {
    max-height: inherit;
    text-align: center;
  }
  tr.flex {
    display: grid;
    grid-template-columns: 1fr 4fr;
  }
}
@media screen and (max-width: 400px) {
  tr.flex {
    grid-template-columns: 1fr;
  }
}
</style>
